import styled from "styled-components";
import ornament from "../../assets/images/ornament.png";
import ornament3 from "../../assets/images/ornament3.png";

export const PageWrap = styled.main`
  width: 100%;
  display: grid;
  gap: 28px;
  background: radial-gradient(
      60% 60% at 50% 38%,
      rgba(0, 0, 0, 0.04),
      transparent 60%
    ),
    #f6f4ef;
  padding: 24px 12px 56px;
`;

export const Section = styled.section`
  width: 100%;
  max-width: 980px;
  margin: 0 auto;
  padding: 12px 8px;
  color: #111;
`;

export const Title = styled.h1`
  margin: 0 0 10px;
  font-size: clamp(26px, 4vw, 42px);
  line-height: 1.1;
  text-align: center;
`;

export const Subtitle = styled.p`
  margin: 0 auto 8px;
  opacity: 0.85;
  text-align: center;
  max-width: 760px;
`;

export const H2 = styled.h2`
  margin: 24px 0 8px;
  font-size: clamp(20px, 2.2vw, 28px);
`;

export const H3 = styled.h3`
  margin: 16px 0 6px;
  font-size: clamp(18px, 1.9vw, 22px);
`;

export const P = styled.p`
  margin: 8px 0;
  line-height: 1.6;
`;

export const Ul = styled.ul`
  margin: 8px 0 8px 20px;
  line-height: 1.6;
  list-style: disc;
`;

export const Ornament = styled.div`
  height: 39px;
  background: url(${ornament3}) no-repeat center;
  background-size: contain;

  @media (max-width: 940px) {
    background: url(${ornament}) no-repeat center;
    height: 42px;
    background-size: contain;
  }
`;
